function loadCallStats() {
    // skip if the panel doesn't exist
    if (!$(".callWaitWrapper").length) { return; }

    $.ajax({
        url: "/Header/CallWaitTime",
        dataType: "html",
        timeout: 20000,
        type: "GET",
        success: function (msg) {
            $(".callWaitWrapper").hide().after(msg);
        }
    });
}

function loadUserLinks() {
    $.ajax({
        url: "/Header/UserSpecificLinks",
        cache: false,
        dataType: "html",
        timeout: 20000,
        type: "GET",
        success: function (msg) {
            $("#userSpecificLinksBox").html(msg);
            //console.log("message " + msg);
            init_dropdown();
            init_mobileSearch();
            init_accountsummary();
            init_cartsummary();     
        }
    });
}

function init_accountsummary() {
	//Wire up hoverintent
	var accountTrigger = document.getElementById("accountTrigger");
	hoverintent(accountTrigger, 
		function(){ showAccountView(); }, 
		function(){ hideAccountView(); }
	);    
	//$("div.accountsummary_trigger").hoverIntent(showAccountView, hideAccountView);
}

function showAccountView() {
    //nudge cartview to the left
    var tt, tt_alt;
    var cv_exp;
    var cv = $(".accountsummary_view");
    var cv_left = $("a.accountsummary_trigger");
    cv.css("left", cv_left);
    $(".accountsummary_view").slideDown("fast");
    $("#lnkAccountSummary").attr("aria-expanded", "true");
    $("body").on("keydown", function(e){
    	if((e.which || e.keyCode) === 27){ // allow user to close on escape
    		hideAccountView();
    	}
    });
}

function hideAccountView() {
    $(".accountsummary_view").slideUp("fast");
    $("#lnkAccountSummary").attr("aria-expanded", "false");
}

function init_cartsummary() {
	//Wire up hoverintent
	var cartTrigger = document.getElementById("cartTrigger");
    	hoverintent(cartTrigger, 
		function(){ showCartView(); }, 
		function(){ hideCartView(); }
	);    
    //$("div.cartsummary_trigger").hoverIntent(showCartView, hideCartView);
}

function showCartView() {
    //nudge cartview to the left
    var tt, tt_alt;
    var cv_exp;
    var cv = $(".cartsummary_view");
    var cv_left = $("a.cartsummary_trigger");
    cv.css("left", cv_left);
    $(".cartsummary_view").addClass('showing').slideDown("fast");
    $("#lnkCartSummary").attr("aria-expanded", "true");
    lazyloadImages.update();
    $("body").on("keydown", function(e){
    	if((e.which || e.keyCode) === 27){ // allow user to close on escape
    		hideCartView();
    	}
    });
}

function hideCartView() {
    $(".cartsummary_view").removeClass('showing').slideUp("fast");
    $("#lnkCartSummary").attr("aria-expanded", "false");
}

function init_dropdown() {
    //breakout if none exists
    if (!$("ul.dropdown").length) { return; }

    //add hover event listener
    $("ul.dropdown li.dropdown_trigger").hover(
        function () {
            $(this).find("ul").fadeIn(1);
        },
        function () {
            $(this).find("ul").hide();
        }
    );
}

function init_mobileSearch() {
	$("#showMobileSearch").on("click", function(){
		var searchBar = $(this).parent().parent().parent().next(".HeaderSearchBar");
		if(searchBar.hasClass("show")){
			searchBar.removeClass("show").addClass("hide");
			$("#showMobileSearch").removeClass("bkgdLtGray").attr("aria-expanded", "false").focus();
		}else{
			searchBar.removeClass("hide").addClass("show");
			$("#showMobileSearch").addClass("bkgdLtGray").attr("aria-expanded", "true");
			$("#txtSearch").focus();
		}
	});
}

function gotoLiveChat2() {
    var ajaxCall = $.ajax({
            type: "POST",
            url: "/Header/GetUserID",
            dataType: "json",
            timeout: 15000,
            success: function (result) {
                return result;
            }
     });

    $.when(ajaxCall).done(function(data){
    	    var UserID = "Anon_Web_User";
    	    if(!data.Anonymous){
    	      UserID = data.Email;
    	    }
           var url = "https://chat.4imprint.com/i3root/examples/bypassloginform/chatorcallback.html?chatUsername=" + UserID;
    	    window.open(url, "OnlineHelp", "status=0,width=750,height=550, top=10, left=10, scrollbars=1");
    });
}

function isMobileDevice() {
	if(window.location.hostname.indexOf("m.4imprint.") < 0 && window.location.hostname.indexOf("mobiledev.4imprint.") < 0) {
		$.get("/Header/IsMobileDevice", function (data) {
			if(data !== null && data !== ""){
	        		$("#mobileLink").html(data).show();
			}
    		});
    	}
}

$(function () {
    loadUserLinks();
    loadCallStats();
    isMobileDevice();
     
    if ($("#chatlink").length > 0) {
        $.ajax({
            type: "POST",
            url: "/Header/IsOfficeOpen",
            dataType: "json",
            timeout: 15000,
            async: true,
            success: function (result) {
                if (!result.OfficeOpen) {
                    $("#chatlink").hide();
                }
            }
        });
    }    
    
    $("#mobileLink").on("click", function () {
        $.get("/Header/UpdateMobilePreferences");
    });
    
    if(document.getElementById("initChat")){
		document.getElementById("initChat").addEventListener("click", function(e){
			e.preventDefault();
			gotoLiveChat2();
		});
	}
});